import React from 'react';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#F5EDE4] border-t border-[#E8DCC8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="font-heading text-xl font-semibold text-[#8B7355] mb-4">
              YA Studio Production
            </h3>
            <p className="font-body text-sm text-[#6B5845] leading-relaxed">
              Photographe maternité et naissance à Haguenau depuis 9 ans. Plus de 550 familles nous ont fait confiance.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-[#8B7355] mb-4">
              Navigation
            </h3>
            <ul className="space-y-2 font-body text-sm">
              <li>
                <Link to="/" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/naissance" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  Naissance
                </Link>
              </li>
              <li>
                <Link to="/grossesse" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  Grossesse
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#6B5845] hover:text-[#8B7355] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact */}
          <div>
            <h3 className="font-heading text-lg font-semibold text-[#8B7355] mb-4">
              Contact
            </h3>
            <ul className="space-y-3 font-body text-sm text-[#6B5845]">
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="text-[#8B7355] mt-1 flex-shrink-0" />
                <span>Haguenau, Alsace</span>
              </li>
              <li className="flex items-start space-x-2">
                <Phone size={16} className="text-[#8B7355] mt-1 flex-shrink-0" />
                <span>06.27.16.94.94</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail size={16} className="text-[#8B7355] mt-1 flex-shrink-0" />
                <span>yastudio67@outlook.fr</span>
              </li>
              <li className="flex items-start space-x-2">
                <Instagram size={16} className="text-[#8B7355] mt-1 flex-shrink-0" />
                <a 
                  href="https://www.instagram.com/yastudio_photography/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-[#8B7355] transition-colors"
                >
                  @yastudio_photography
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Nos Prestations Section */}
        <div className="mt-12 pt-8 border-t border-[#E8DCC8]">
          <h3 className="font-heading text-2xl font-semibold text-[#8B7355] mb-6 text-center">
            Nos Prestations
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {/* Photographe événementiel */}
            <a 
              href="https://www.yastudioproduction.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5845] hover:from-[#6B5845] hover:to-[#8B7355] p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <h4 className="font-heading text-lg font-semibold text-white mb-2 text-center">
                  📸 Photographe Événementiel
                </h4>
                <p className="font-body text-sm text-[#FAF8F5] text-center">
                  Capturer vos moments spéciaux
                </p>
              </div>
            </a>

            {/* Vidéaste mariage */}
            <a 
              href="https://www.yastudioproduction.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5845] hover:from-[#6B5845] hover:to-[#8B7355] p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <h4 className="font-heading text-lg font-semibold text-white mb-2 text-center">
                  🎥 Vidéaste Mariage Alsace
                </h4>
                <p className="font-body text-sm text-[#FAF8F5] text-center">
                  Films de mariage émotionnels
                </p>
              </div>
            </a>

            {/* Photographe mariage */}
            <a 
              href="https://www.yastudioproduction.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-gradient-to-br from-[#8B7355] to-[#6B5845] hover:from-[#6B5845] hover:to-[#8B7355] p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                <h4 className="font-heading text-lg font-semibold text-white mb-2 text-center">
                  💍 Photographe de Mariage Alsace
                </h4>
                <p className="font-body text-sm text-[#FAF8F5] text-center">
                  Immortaliser votre jour unique
                </p>
              </div>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-[#E8DCC8]">
          {/* Zone d'intervention */}
          <div className="mb-6 text-center">
            <h4 className="font-heading text-base font-semibold text-[#8B7355] mb-3">
              📍 Zone d'intervention - Photographe Maternité Alsace
            </h4>
            <p className="font-body text-sm text-[#6B5845] leading-relaxed max-w-4xl mx-auto">
              Photographe maternité et naissance à <strong>Haguenau</strong>, <strong>Gundershoffen</strong>, <strong>Strasbourg</strong>, Saverne, Bischwiller, Brumath, Obernai, Wissembourg, Sélestat et dans tout le <strong>Bas-Rhin (67)</strong> et l'<strong>Alsace Grand Est</strong>. Déplacements possibles pour séances photo grossesse à domicile.
            </p>
          </div>

          <div className="mb-4 text-center">
            <img 
              src="https://via.placeholder.com/120x60/8B7355/FFFFFF?text=Top+3+Strasbourg" 
              alt="Three Best Rated Top 3 Strasbourg" 
              className="mx-auto h-16 opacity-80"
            />
          </div>
          <p className="font-body text-xs text-[#6B5845] text-center">
            YA Studio Production - Photographe Maternité Haguenau | SIREN : À renseigner
          </p>
          <p className="font-body text-xs text-[#8B7355] mt-2 text-center">
            Mots-clés : Photographe maternité Haguenau, Photographe grossesse Gundershoffen, Photographe naissance Strasbourg, Séance photo grossesse Alsace, Photographe nouveau-né Bas-Rhin, Studio photo bébé Haguenau
          </p>
          <p className="font-body text-xs text-[#6B5845] mt-4 text-center">
            © {new Date().getFullYear()} YA Studio Production. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;